export type Testimonial = {
  initials: string
  name: string
  role: string
  text: string
}

export const stripTestimonials: Testimonial[] = [
  {
    initials: 'RM',
    name: 'R.M.',
    role: 'Hybrid Fitness Coach — London, UK',
    text: 'I stopped spending my Sunday nights building session structures from scratch. I open the library, select the objective, and walk to the track completely prepared. My athletes feel the difference — and so do I.',
  },
  {
    initials: 'DP',
    name: 'D.P.',
    role: 'Hybrid Fitness Coach — Toronto, Canada',
    text: 'The Coaching Cues, Corrections and Common Mistakes guide saved me countless times in my first month. That bonus alone is worth the entire investment.',
  },
  {
    initials: 'AK',
    name: 'A.K.',
    role: 'Hybrid Fitness Coach — Sydney, Australia',
    text: 'The 120 sessions and race simulations completely transformed how I coach. My sessions are more intentional, my athletes stay engaged, and every workout feels structured from beginning to end.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'VT',
    name: 'V.T.',
    role: 'Hybrid Fitness Coach — New York, USA',
    text: "The running under fatigue and station progressions completely transformed how my athletes develop. Every week truly feels like real progress — and I'm not the one scrambling to decide what that should be.",
  },
  {
    initials: 'CR',
    name: 'C.R.',
    role: 'Hybrid Fitness Coach — Melbourne, Australia',
    text: 'I used to get nervous whenever an athlete of a different level joined the group. Now I open the system and have multiple versions of each concept ready before anyone walks in. The scaling options changed everything.',
  },
  {
    initials: 'DG',
    name: 'D.G.',
    role: 'Hybrid Fitness Coach — Toronto, Canada',
    text: "I review the key coaching cues before every session and walk to the track knowing exactly what I'm going to say. The Mistakes and Corrections guide is something I use every single week without exception.",
  },
  {
    initials: 'AM',
    name: 'A.M.',
    role: 'Hybrid Fitness Academy Coach — London, UK',
    text: "The Assessment System saved my whole coaching program. I had everything organized — skill evaluations, progress notes, priority lessons — all in one place. My athletes could finally see exactly how far they've come.",
  },
  {
    initials: 'SR',
    name: 'S.R.',
    role: 'Hybrid Fitness Coach — Dublin, Ireland',
    text: 'The 150 drills completely changed how I design workouts. My athletes talk about those sessions for weeks. They feel like real experiences — not just another repetitive conditioning block.',
  },
]
